export function fx_JobStamp(
  schedulerJobDocId: string,
  company: string,
  beginSelectedDate: string,
  endSelectedDate: string,
  location: string,
  locationCoordinates: string,
  pay: string,
  jobId: string,
  notes: string,
  numJobSlots: number,
  isNewMessage: boolean,
  isPaidJob: boolean,
  isPaidWerker: boolean,
  isPaidWerkers: boolean,
  isRead: boolean,
  jobCancelledByScheduler: boolean,
  jobStatusSched: string,
  werkerStatus: string,
  scheduledCount?: number
) {
  // 1 - Set the color for the icon based on werker's paid status.

  // 2 - Create the jobObject.
  const jobObject = {
    core: {
      uniqueJobId: schedulerJobDocId,
      company: company,
      dateTimeStart: beginSelectedDate,
      dateTimeFinish: endSelectedDate,
      location: location,
      locationCoordinates: locationCoordinates,
      pay: pay,
      shiftIdentifier: jobId,
      shiftNotes: notes,
      numJobSlots: numJobSlots,
    },
    status: {
      isNewMessage: isNewMessage, // user has a new message on the job
      isPaidJob: isPaidJob, // scheduler has received payment on the job
      isPaidWerker: isPaidWerker, // this werker has been paid
      isPaidWerkers: isPaidWerkers, // all werkers have been paid
      isRead: isRead, // doc has been read by owner
      jobCancelledByScheduler: jobCancelledByScheduler,
      jobStatusSched: jobStatusSched,
      jobStatusWerker: werkerStatus,
      jobInvoiced: false,
      ...(typeof scheduledCount === "number" && Number.isFinite(scheduledCount)
        ? { scheduledCount }
        : {}),
    },
  };
  // 3 - Return for processing into the array, state, etc.
  return jobObject;
}

// const jobStamp = fx_JobStamp(
// schedulerJobDocId: string,
// company: string,
// beginSelectedDate: string,
// endSelectedDate: string,
// location: string,
// pay: string,
// jobId: string,
// notes: string,
// numJobSlots: number,
// isNewMessage: boolean,
// isPaidJob: boolean,
// isPaidWerker: boolean,
// isPaidWerkers: boolean,
// isRead: boolean,
// jobCancelledByScheduler: boolean,
// jobStatusSched: string,
// werkerStatus: string,
// );
